/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/fubo_context.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FuboNameSpace } from "./common_enums";
/**
 * TODO: move to common when reconstructing
 *
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.FuboContext
 */
export interface FuboContext {
    /**
     * @generated from protobuf field: optional string fubo_service = 1;
     */
    fubo_service?: string;
    /**
     * @generated from protobuf field: fubo.tv.proto.common.v3.generic.FuboNameSpace fubo_namespace = 2;
     */
    fubo_namespace: FuboNameSpace;
    /**
     * @generated from protobuf field: bool up_event = 3;
     */
    up_event: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class FuboContext$Type extends MessageType<FuboContext> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.FuboContext", [
            { no: 1, name: "fubo_service", kind: "scalar", localName: "fubo_service", opt: true, T: 9 /*ScalarType.STRING*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "de-fe-receiver-release-2023-W28-02", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "${application_name}-${release_version}, used to track event journey." } },
            { no: 2, name: "fubo_namespace", kind: "enum", localName: "fubo_namespace", T: () => ["fubo.tv.proto.common.v3.generic.FuboNameSpace", FuboNameSpace], options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "papi", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "// Used to differentiate events from different system scopes, events that are from same system scope should share same FuboNameSpace value. In schema, FuboNameSpace is also included in package name, e.g. all events defined in package `fubo.tv.proto.services.papi.v3.tracking` have FuboNameSpace value `papi`" } },
            { no: 3, name: "up_event", kind: "scalar", localName: "up_event", T: 8 /*ScalarType.BOOL*/, options: { "fubo.tv.proto.common.v3.custom.SchemaDescription.field_example": "true", "fubo.tv.proto.common.v3.custom.SchemaDescription.field_description": "Used to differentiate events from up and non up application." } }
        ]);
    }
    create(value?: PartialMessage<FuboContext>): FuboContext {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.fubo_namespace = 0;
        message.up_event = false;
        if (value !== undefined)
            reflectionMergePartial<FuboContext>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: FuboContext): FuboContext {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string fubo_service */ 1:
                    message.fubo_service = reader.string();
                    break;
                case /* fubo.tv.proto.common.v3.generic.FuboNameSpace fubo_namespace */ 2:
                    message.fubo_namespace = reader.int32();
                    break;
                case /* bool up_event */ 3:
                    message.up_event = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: FuboContext, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string fubo_service = 1; */
        if (message.fubo_service !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.fubo_service);
        /* fubo.tv.proto.common.v3.generic.FuboNameSpace fubo_namespace = 2; */
        if (message.fubo_namespace !== 0)
            writer.tag(2, WireType.Varint).int32(message.fubo_namespace);
        /* bool up_event = 3; */
        if (message.up_event !== false)
            writer.tag(3, WireType.Varint).bool(message.up_event);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.FuboContext
 */
export const FuboContext = new FuboContext$Type();
